import { endOfDay } from 'date-fns';
import { useCallback, useEffect, useState } from 'preact/hooks';
import { buildURL } from 'Shared/fetch';
import useFetch, { CachePolicies } from 'use-http';

const useScheduleCount = () => {
  const { get } = useFetch(buildURL('/schedules/events'), {
    credentials: 'include',
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const [count, setCount] = useState(0);

  const getSchedule = useCallback(async () => {
    const params = new URLSearchParams();
    const now = new Date();
    params.append('startTime', `${now.getTime()}`);
    params.append('endTime', `${endOfDay(now).getTime()}`);
    const schedulesData = await get(params as unknown as string);
    setCount(schedulesData?.length ?? 0);
  }, [setCount, get]);

  useEffect(() => {
    getSchedule();
  }, [getSchedule]);

  return count;
};

export default useScheduleCount;
